const classNames = (...classes: string[]) => {
	return classes.filter(c => c).join(' ');
}

export { classNames, classNames as c }
